<div class="vehicle-premium-tile">
  <div class="tile-header">
    {{ vehicle.year }} {{ vehicle.make }} {{ vehicle.model }}
    <span class="badge nwx-badge" [class]="currentProgram">{{
      formatEnrollmentStatus()
    }}</span>
    @if (discountPercentage) {
      <span class="pl-5">
        Applied discount of
        <h3 class="discount-percentage">{{ discountPercentage }}%</h3>
      </span>
    }
  </div>
  <div class="tile-body">
    <div class="bolt-container-fluid">
      <div class="bolt-row bolt-align-items-center">
        @if (needsRecalc) {
          <div class="bolt-col-xs-12 bolt-col-sm-auto price">
            <h4>$--.--/month*</h4>
          </div>
        }
        @if (!needsRecalc) {
          <div
            class="bolt-col-xs-12 bolt-col-sm-auto price with-border"
            >
            <h3>
              {{ monthlyPremium | currency }}
              <span class="bolt-heading-sm">
                <strong>/ month<sup>*</sup></strong>
              </span>
            </h3>
            @if (currentProgram === 'SmartMiles') {
              <p class="bolt-body-copy-sm">
                @if (vehicle.totalCostPerMile) {
                  {{ vehicle.totalCostPerMile | currency }} cost per mile
                } @else {
                  Rate quote to see cost per mile
                }
              </p>
            }
          </div>
        }
        @if (!needsRecalc) {
          <div
            class="bolt-col-xs-12 bolt-col-sm-4 price-desc"
            >
            @if (currentProgram === 'SmartMiles') {
              <span>
                Estimated average monthly cost for this vehicle
              </span>
            } @else {
              Monthly cost for this vehicle
            }
          </div>
        }
        <div class="bolt-col-xs-12 bolt-col-sm">
          @if (allowChange) {
            <div class="change-btn">
              <bolt-button
                type="solid"
                attr.id="tvpc-change-enroll-vehicle-{{ vehicle.vehicleId }}"
                (click)="openChangeModal($event)"
                [attr.size]="maxSizeMini ? 'sm' : 'md'"
                >{{
                currentProgram !== 'NotEnrolled'
                ? 'Change/remove enrollment'
                : 'Enroll vehicle'
                }}</bolt-button
                >
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
